import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBarClosed from "./SideBarClosed";
import SideBarOpen from "./SideBarOpen";
import DashboardLayout from "./DashboardLayout";
import { getBalances } from "../features/dropdown/dropdownSlice";

export default function SideBar() {
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const dispatch = useDispatch();



  useEffect(() => {}, [sideMenuCollapsed]);

  if (sideMenuCollapsed) return <SideBarClosed />;

  return <SideBarOpen />;
}
